import { ReactNode, useCallback, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import LayoutBox from 'common/presentation/baseLayout/LayoutBox';
import ModalHeader from './ModalHeader';
import Main from 'common/presentation/baseLayout/Main';
import { BeforeMockModalCloseHandler } from './hooks/useBeforeCloseHandler';

export default function MockModalLayout() {
  const [modalTitle, setModalTitle] = useState('');
  const [modalHeaderContent, setModalHeaderContent] = useState<ReactNode>(null);
  const [beforeMockModalCloseHandler, setBeforeMockModalCloseHandler] =
    useState<BeforeMockModalCloseHandler>(() => () => {});

  const handleModalTitleChange = useCallback((title: string) => {
    setModalTitle(title);
  }, []);

  const outletContext = useMemo(
    () => ({
      onModalTitleChange: handleModalTitleChange,
      onModalHeaderContentChange: setModalHeaderContent,
      setBeforeMockModalCloseHandler,
      beforeMockModalCloseHandler,
    }),
    [handleModalTitleChange, beforeMockModalCloseHandler]
  );

  return (
    <Main>
      <ModalHeader title={modalTitle} beforeMockModalCloseHandler={beforeMockModalCloseHandler}>
        {modalHeaderContent}
      </ModalHeader>

      <LayoutBox>
        <Outlet context={outletContext} />
      </LayoutBox>
    </Main>
  );
}
